<sc-activity-feed [scAnchorTarget]="'Aktivitäten'" *ngIf="project" [user]="userService.me" [uri]="activitiesUri" [readOnly]="true" [condensed]="false" [language]="loc.language" (navigate)="navigate($event)">
    <ng-template let-activity="activity">
        <sc-activity-item [activity]="activity" [condensed]="false" [showProjectName]="false" [language]="loc.language"></sc-activity-item>
    </ng-template>
</sc-activity-feed>